import * as React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { ListItemIcon, ListSubheader, Grid } from '@mui/material'
import HeatPumpIcon from '@mui/icons-material/HeatPump'
import schema from '../../schemas/heatpump.json'
import { JSONSchema7 } from 'json-schema'
import { HeatPump } from '../../interfaces/heatpump'
import CreateHeatPump from './CreateHeatPump'
import EditHeatPump from './EditHeatPump'
import DeleteHeatPump from './DeleteHeatPump'

export interface Props {
  disabled: boolean
  data: HeatPump[]
  setData: React.Dispatch<React.SetStateAction<any[]>>
}

export default function HeatPumpList({ disabled, data, setData }: Props) {
  return (
    <List
      dense
      subheader={
        <ListSubheader>
          <Grid container alignItems={'center'}>
            {'Heat Pumps'}
            <CreateHeatPump disabled={disabled} data={data} schema={schema as JSONSchema7} setData={setData} />
          </Grid>
        </ListSubheader>
      }
    >
      {data.map((obj: HeatPump, index: number) => {
        return (
          <ListItem
            key={index}
            secondaryAction={
              <>
                <EditHeatPump disabled={disabled} schema={schema as JSONSchema7} value={obj} setData={setData} />
                <DeleteHeatPump disabled={disabled} value={obj} setData={setData} />
              </>
            }
            disablePadding
          >
            <ListItemButton disabled={disabled}>
              <ListItemIcon>
                <HeatPumpIcon />
              </ListItemIcon>
              <ListItemText
                primary={obj.name}
                secondary={`type: ${obj.type_} | compression stages: ${obj.nr_stages}`}
                sx={{ '.MuiListItemText-secondary': { display: { xs: 'none', sm: 'block' } } }}
              />
            </ListItemButton>
          </ListItem>
        )
      })}
    </List>
  )
}
